<template>
  <div id="classall">
    <!--课程弹窗-->
    <div id="popup-all">
      <h3>全部</h3>
      <ul>
<!--        <li><p>第一节（已更新）</p><span></span></li>-->
<!--        <li class="playing"><p>当前课程</p><span></span></li>-->
        <li v-for="(item, index) in videoList" :key="index" @click="playVideo(item.video_id)" :alt="item.channel_vid" :class="current_video_id === item.video_id ? 'playing' : ''">
          <p>{{index + 1}} | {{item.name}}</p>
          <span></span>
        </li>
      </ul>
    </div>
    <div class="bg" @click="hideList()"></div>
  </div>
</template>

<script>
export default {
  name: 'ClassAll',
  data () {
    return {
      videoList: {}
    }
  },
  props: [
    'class_id',
    'course_id',
    'current_video_id'
  ],
  mounted () {
    this.getVideoList()
  },
  methods: {
    getVideoList () {
      let data = {
        class_id: this.class_id,
        course_id: this.course_id
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_timetable',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.videoList = res.data.data
            console.log(this.videoList)
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    playVideo (videoId) {
      this.$emit('listenVid', this.course_id, videoId)
      this.$emit('listenShow')
    },
    hideList () {
      this.$emit('listenShow')
    }
  }
}
</script>

<style scoped lang="stylus">
  #classall
    #popup-all
      position: fixed
      bottom: 0
      left: 0
      z-index: 10001
      width: 7.5rem
      height: 9.1rem
      padding: .4rem
      background-color: #fff
      h3
        width: 1.36rem
        line-height: .6rem
        background-color: #EEEEEE
        font-size: .26rem
        color: #5D5D5D
        text-align: center
        -webkit-border-radius: .3rem
        -moz-border-radius: .3rem
        border-radius: .3rem
      ul
        li
          display: flex
          justify-content: space-between
          align-items: center
          width: 6.7rem
          height: .94rem
          border-bottom: .02rem solid #F2F2F2
          p
            font-size: .28rem
            color: #2E2E2E
          &.playing
            p
              color: #FF6445
            span
              display: block
              width: .4rem
              height: .4rem
              background: url(../../../../assets/icon/classall_icon_tick.png) no-repeat center
              -webkit-background-size: 100%
              background-size: 100%
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: 10000
      width: 100%
      height: 100%
      background-color: rgba(0, 0, 0, .4)
</style>



// WEBPACK FOOTER //
// src/components/share/popup/class/ClassAll.vue